type CrossAltProps = React.ComponentPropsWithoutRef<'svg'>;

export const CrossAlt: React.FC<CrossAltProps> = ({
  ...props
}: CrossAltProps) => {
  return (
    <svg
      width="6"
      height="6"
      viewBox="0 0 6 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.47132 0.52827C5.73167 0.788619 5.73167 1.21073 5.47132 1.47108L3.94273 2.99967L5.47132 4.52827C5.73167 4.78862 5.73167 5.21073 5.47132 5.47108C5.21097 5.73143 4.78886 5.73143 4.52851 5.47108L2.99992 3.94248L1.47132 5.47108C1.21097 5.73143 0.788863 5.73143 0.528514 5.47108C0.268165 5.21073 0.268165 4.78862 0.528514 4.52827L2.05711 2.99967L0.528514 1.47108C0.268165 1.21073 0.268165 0.788619 0.528514 0.52827C0.788863 0.26792 1.21097 0.26792 1.47132 0.52827L2.99992 2.05687L4.52851 0.52827C4.78886 0.26792 5.21097 0.26792 5.47132 0.52827Z"
        fill="currentColor"
      />
    </svg>
  );
};
